/* Initialize Flickity */
let options = {
  prevNextButtons: true,
  pageDots: true,
  draggable: false,
  contain: true,
  cellAlign: 'left',
  adaptiveHeight: true,
  dragThreshold: 8,
  groupCells: 2
};

if ( matchMedia('screen and (min-width: 1024px)').matches ) {

  $('.main-carousel').flickity({
    groupCells: 3,
  })
}

if ( matchMedia('screen and (max-width: 768px)').matches ) {
  options.groupCells = 1;
}

$('.main-carousel').flickity( options );